import "./progress-bar.css";
import { ProgressBar } from './progress-bar';
export default ProgressBar;